import { render, staticRenderFns } from "./PdfBlock.vue?vue&type=template&id=7bed5974&scoped=true&"
import script from "./PdfBlock.vue?vue&type=script&lang=js&"
export * from "./PdfBlock.vue?vue&type=script&lang=js&"
import style0 from "./PdfBlock.vue?vue&type=style&index=0&id=7bed5974&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bed5974",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
